module.exports = __webpack_public_path__ + "img/about-mobile.6d546468.png";